import { createSelector } from 'reselect';

const getState = (state) => state.projects;

export const getLoading = createSelector(getState, (state) => !!state.loading);
export const getLoadingSubmit = createSelector(getState, (state) => !!state.loadingSubmit);
export const getProjects = createSelector(getState, (state) => state.data);
export const getProject = createSelector(getState, (state) => state.project);
